import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const ITGoodsInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="IT Goods"
    sectionKey="IT Goods"
    backRoute="/sections/it-goods"
  />
);

export default ITGoodsInternalTransfer;
